import { FloorLampOutlineIcon } from './FloorLampOutlineIcon';

/**
 * author: Teodor Sandu
 * id 9768571C-CF87-4146-A9AF-A4E76BBD9248
 * name floor-lamp-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/floor-lamp-outline.svg
 * tags
 * - Home Automation 
 */
export const FloorLightOutlineIcon = FloorLampOutlineIcon;
export default FloorLightOutlineIcon